export default {
      id: "copy-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#copy",
      toString: function () {
        return this.url;
      }
    }